import React from 'react'
import './style.css'

export default function inputs(props) {
    return (
        <div className="form">
           <p>{props.text_form}</p>  
           <div className="form-input">
             {props.title}
            <input type={props.type} name={props.name} />
            <small>{props.small}</small>
          </div>
        </div>
    )
}
